import { render, staticRenderFns } from "./CampoPesquisa.vue?vue&type=template&id=60da1070&scoped=true"
import script from "./CampoPesquisa.vue?vue&type=script&lang=js"
export * from "./CampoPesquisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da1070",
  null
  
)

export default component.exports